import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  userAdded = new EventEmitter<void>();
  departmentAdded = new EventEmitter<void>();

  constructor() {}

  emitUserAdded(): void {
    this.userAdded.emit();
  }

  emitDepartmentAdded(): void {
    this.departmentAdded.emit();
  }
}
